import React, { FC, useEffect, useState, useCallback, useRef } from "react";

import { AxiosError } from "axios";
import { Button, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExport } from "@fortawesome/free-solid-svg-icons";
import useSpinnerLoader from "../../../../shared/components/spinner-loader";
import TableHeaderOrdering, {
  Header,
  OrderData,
} from "../../../../shared/components/table-header-ordering";
import { notificationService } from "../../../../shared/services/notification-service";
import TableRowNoData from "../../../../shared/components/molecules/commons/table-row-no-data";
import { HrOnlineService } from "../../../../shared/services/Report/HrOnline/hr-online";
import {
  Document,
  Page,
  View,
  Text,
  PDFDownloadLink,
  Font,
  StyleSheet,
} from "@react-pdf/renderer";

import moment from "moment";
// Type definition for PDFDownloadLink render function
Font.register({
  family: "kanit-regular",
  src: "https://fonts.gstatic.com/s/kanit/v1/L6VKvM17ZmevDynOiw7H9w.ttf",
});
Font.register({
  family: "kanit-200",
  src: "https://fonts.gstatic.com/s/kanit/v1/wfLWkj1C4tYl7MoiFWS3bA.ttf",
});
interface PDFDownloadLinkRenderProps {
  blob: Blob | null;
  url: string | null;
  loading: boolean;
  error: Error | null;
}

// ลงทะเบียนฟอนต์ kanit-200
Font.register({
  family: "kanit-200",
  src: "data:font/truetype;base64,AAEAAAATAQAABAAwRkZUTYYwf2YAAIdQAAAAHEdERUYAJwBmAACHMAAAAB5PUy8yVrxJ2AAAAVgAAABgY21hcAB9wSoAAAHIAAABSmN2dCAHYBmwAAAPyAAAACpmcGdtD7QvpwAADCQAAAJlZ2FzcAAAABAAAAcoAAAACGdseWYl3vHlAAAQkAAAYRxoZWFkAp1o3AAAAT4AAAA2aGhlYQfeA3EAAAFsAAAAJGhtdHgHKATGAAAB8AAAAYpsb2NhPldWLAAAEBwAAADObWF4cAIkAK0AAAG8AAAAIG5hbWUzIkcqAACRfAAAAf5wb3N0AAMAAAACS0AAAAgAAQAAAAEAAHFVy0pfDzz1AB8D6AAAAADUvX8JAAAAANS9fwkAAP8gA+gDYwAAAAgAAgAAAAAAAAABAAADYP8gAFwD6AAAAAAGsQABAAAAAAAAAAAAAAAAAAAAGQABAAAAGQBPAAcAAAAAAAIAAAABAAEAAABAAAAAAAAAAAEDYAGQAAUACAKZAswAAACPApkCzAAAAesAMwEJAAACAAUDAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAQAAh4AYDYAAAAFwDYADgAAAAAQAAAAAAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAD6AAAA+gAAAPoAAAAAAMAAAADAAAAHAABAAAAAABEAAMAAQAAABwABAAoAAAABgAEAAEAAgAh4Ab//wAAACHgAP///+EgAQABAAAAAAAAAAABBgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAIgAAATICqgADAAcAKUAmAAAAAwIAA1cAAgEBAksAAgIBTwQBAQIBQwAABwYFBAADAAMRBQ8rMxEhESczESMiARDuzMwCqv1WIgJmAAAABQAs/+EDvAMYABYAMAA6AFIAXgF3S7ATUFhASgIBAA0ODQAOZgADDgEOA14AAQgIAVwQAQkICgYJXhEBDAYEBgxeAAsEC2kPAQgABgwIBlgACgcFAgQLCgRZAA4ODVEADQ0KDkIbS7AXUFhATAIBAA0ODQAOZgADDgEOA14AAQgIAVwQAQkICgoJXhEBDAYEBgxeAAsEC2kPAQgABgwIBlgACgcFAgQLCgRZAA4ODVEADQ0KDkIbS7AYUFhATQIBAA0ODQAOZgADDgEOA14AAQgIAVwQAQkICgoJXhEBDAYEBgxeAAsEC2kPAQgABgwIBlgACgcFAgQLCgRYAA4NDQ5RAA4ODU8ADQ4NQxtATgIBAA0ODQAOZgADDgEOAwFmAAEICAFcEAEJCAoICQpmEQEMBgQGDAR", // Base64 encoded font data here
});

// Define styles
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: "kanit-200",
  },
  header: {
    fontSize: 16,
    textAlign: "center",
    marginBottom: 3,
  },
  subHeader: {
    fontSize: 14,
    textAlign: "center",
    marginBottom: 10,
  },
  table: {
    display: "flex",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
  },
  tableRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
  },
  tableCol: {
    width: "25%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
  },
  tableCell: {
    fontSize: 12,
    padding: 5,
  },
});

const thaiMonths = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

const ReportManpowerFrameworkOverviewListPage: FC = () => {
  const [queryParams, setQueryParams] = useState<any>({
    ordering_field: "",
    ordering: "",
    page: 1,
    page_size: 10,
    year: moment().year() + 543,
  });
  const [data, setData] = useState<any>([]);
  const [dataExport, setDataExport] = useState<any>([]);
  const { loaderComponent, startLoading, stopLoading } = useSpinnerLoader();
  const loadingRef = useRef({ startLoading, stopLoading });
  loadingRef.current = { startLoading, stopLoading };

  const headers: Header[] = [
    {
      label: "พนักงาน",
      field: "type",
      order: null,
      isOrder: true,
    },
    {
      label: "กรอบ",
      field: "total_power_rate",
      order: null,
      isOrder: true,
    },
    {
      label: "บรรจุจริง",
      field: "actual_filled",
      order: null,
      isOrder: true,
    },
    {
      label: "คิดเป็นร้อยละของพนักงานทั้งหมด",
      field: "vacant_positions",
      order: null,
      isOrder: true,
    },
  ];

  const fetchData = useCallback(
    async (params: any) => {
      loadingRef.current.startLoading();
      try {
        const result =
          await HrOnlineService.getReportManpowerFrameworkOverviewList(params);
        setData(result);
        setDataExport(result);
      } catch (error) {
        const err = error as AxiosError;
        notificationService.dangerNotification(
          "โหลดข้อมูลไม่สำเร็จ",
          err.message
        );
      } finally {
        loadingRef.current.stopLoading();
      }
    },
    [queryParams.ordering_field, queryParams.ordering]
  );

  const tableRowNoData = () => {
    if (data.rows?.employee?.length === 0) {
      return <TableRowNoData colspan={7} />;
    }
    return null;
  };

  const PDF: React.FC<{ data: any }> = ({ data }) => (
    <Document>
      <Page size="A4" style={{ padding: 20, fontFamily: "kanit-regular" }}>
        <View>
          {/* หัวรายงาน */}
          <View style={{ marginBottom: 20 }}>
            <Text
              style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 3,
                fontFamily: "kanit-200",
              }}
            >
              องค์การตลาดเพื่อเกษตรกร
            </Text>

            <Text
              style={{
                fontSize: 16,
                textAlign: "center",
                marginBottom: 3,
                fontFamily: "kanit-200",
              }}
            >
              รายงานกรอบอัตตรากำลังผู้บริหาร(ระดับ 8-10) และ
              พนักงานปฎิบัติการ(ระดับ 4-7)
            </Text>

            <Text
              style={{
                fontSize: 14,
                textAlign: "center",
                marginBottom: 10,
                fontFamily: "kanit-200",
              }}
            >
              ประจำวันที่{" "}
              {moment().format("D") +
                " " +
                thaiMonths[moment().month()] +
                " " +
                (moment().year() + 543)}
            </Text>
          </View>

          <View style={{ marginBottom: 10 }} fixed>
            {/* หัวตารางใหม่ตาม Table component */}
            <View
              style={{
                flexDirection: "row",
                padding: 5,
                borderBottomWidth: 1,
                borderTopWidth: 1,
              }}
            >
              <Text
                style={{
                  width: "30%",
                  fontSize: 12,
                  textAlign: "center",
                  fontFamily: "kanit-200",
                }}
              >
                พนักงาน
              </Text>
              <Text
                style={{
                  width: "20%",
                  fontSize: 12,
                  textAlign: "center",
                  fontFamily: "kanit-200",
                }}
              >
                กรอบ
              </Text>
              <Text
                style={{
                  width: "20%",
                  fontSize: 12,
                  textAlign: "center",
                  fontFamily: "kanit-200",
                }}
              >
                บรรจุจริง
              </Text>
              <Text
                style={{
                  width: "30%",
                  fontSize: 12,
                  textAlign: "center",
                  fontFamily: "kanit-200",
                }}
              >
                คิดเป็นร้อยละของพนักงานทั้งหมด
              </Text>
            </View>
            {/* ข้อมูลผู้บริหาร */}
            {data.rows?.manager?.map((item: any, index: any) => (
              <View key={index} style={{ flexDirection: "row", padding: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  ผู้บริหาร(ระดับ 8-10)
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "20%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "20%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}
            {/* ข้อมูลพนักงาน */}
            {data.rows?.employee?.map((item: any, index: any) => (
              <View key={index} style={{ flexDirection: "row", padding: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  พนักงานระดับปฎิบัติการ(ระดับ 4-7)
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "20%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "20%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}

            {/* ลูกจ้างประจำ */}
            {data.rows?.permanent?.map((item: any, index: any) => (
              <View key={index} style={{ flexDirection: "row", padding: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  ลูกจ้างประจำ
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "20%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "20%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}

            {/* ลูกจ้างชั่วคราว */}
            {data.rows?.temporary?.map((item: any, index: any) => (
              <View key={index} style={{ flexDirection: "row", padding: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "left",
                  }}
                >
                  ลูกจ้างชั่วคราว
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "20%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "20%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-200",
                    width: "30%",
                    fontSize: 10,
                    textAlign: "center",
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}

            {/* รวม */}
            {data.rows?.total_all?.map((item: any, index: any) => (
              <View key={index} style={{ flexDirection: "row", padding: 3 }}>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "left",
                    width: "30%",
                  }}
                >
                  รวม
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "center",
                    width: "20%",
                  }}
                >
                  {item.total_power_rate}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "center",
                    width: "20%",
                  }}
                >
                  {item.actual_filled}
                </Text>
                <Text
                  style={{
                    fontFamily: "kanit-regular",
                    fontSize: 10,
                    textAlign: "center",
                    width: "30%",
                  }}
                >
                  {item.percentage}
                </Text>
              </View>
            ))}
          </View>
        </View>
      </Page>
    </Document>
  );

  useEffect(() => {
    fetchData(queryParams);
  }, [fetchData]);

  return (
    <>
      <div className="d-flex justify-content-between py-4">
        <h2 className="text-mof-primary m-0">
          รายงานกรอบอัตตรากำลังผู้บริหาร(ระดับ 8-10) และ พนักงานปฎิบัติการ(ระดับ
          4-7)
        </h2>
      </div>
      {loaderComponent}
      <div className="row">
        {/* <label className="form-label">ปี</label>
        <div className="col-sm-12 col-md-2">
          <input
            className="form-control"
            type="text"
            value={queryParams.year ? queryParams.year : ""}
            onChange={handleYearChange}
            name="search"
          />
        </div>
        <div className="col-sm-12 col-md-4">
          <Button
            variant="primary"
            type="button"
            className="d-inline-block px-4"
            onClick={() => fetchData(queryParams)}
          >
            <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
          </Button>
        </div> */}
        <div className="col-sm-12 col-md-12 d-flex justify-content-end">
          <PDFDownloadLink
            document={<PDF data={dataExport} />}
            fileName={`รายงานกรอบอัตตรากำลังผู้บริหาร(ระดับ 8-10) และ พนักงานปฎิบัติการ(ระดับ 4-7).pdf`}
          >
            {
              (({ loading }: any) => (
                <Button
                  variant="primary"
                  className="btn-action btn-mof-primary me-2"
                  disabled={loading}
                >
                  <FontAwesomeIcon icon={faFileExport} className="me-2" />
                  {loading ? "Loading..." : "Export"}
                </Button>
              )) as any
            }
          </PDFDownloadLink>
        </div>
      </div>

      <div className="overflow-auto mt-3">
        <Table striped bordered hover>
          <thead>
            <TableHeaderOrdering
              headers={headers}
              onChangeOrder={(orderData: OrderData) => {
                setQueryParams({
                  ...queryParams,
                  ordering_field: orderData.field,
                  ordering: orderData.order,
                });
              }}
              isShow={true}
            />
          </thead>
          <tbody>
            {data.rows?.manager?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="ผู้บริหาร(ระดับ 8-10)"
                />
              );
            })}
            {data.rows?.employee?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="พนักงานระดับปฎิบัติการ(ระดับ 4-7)"
                />
              );
            })}
            {data.rows?.permanent?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="ลูกจ้างประจำ"
                />
              );
            })}
            {data.rows?.temporary?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="ลูกจ้างชั่วคราว"
                />
              );
            })}

            {data.rows?.total_all?.map((data: any, index: any) => {
              return (
                <ReportManpowerFrameworkOverviewRow
                  key={index}
                  {...data}
                  index={index + 1}
                  type="รวม"
                  bold={true}
                />
              );
            })}
            {tableRowNoData()}
          </tbody>
        </Table>
      </div>
    </>
  );
};

const ReportManpowerFrameworkOverviewRow: FC<any> = ({
  total_power_rate,
  actual_filled,
  percentage,
  type = null,
  bold = false,
}) => {
  return (
    <tr style={{ fontWeight: bold ? "bold" : "normal" }}>
      <td>{type}</td>
      <td>{total_power_rate}</td>
      <td>{actual_filled}</td>
      <td>{percentage}</td>
    </tr>
  );
};

export default ReportManpowerFrameworkOverviewListPage;
